/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { connect } from "react-redux";
import { Menu } from "./index";
import PropTypes from "prop-types";
import get from "lodash/get";
import { getMenuData } from "../header-helper-components";

const DefaultMenuBase = ({ menu, domainSlug, publisherTheme, closeAll, customCssClasses = "", isSingleLayer }) => {
  return (
    <Menu
      menu={getMenuData(menu, "default", domainSlug)}
      languageDirection={get(publisherTheme, ["language_direction"], "left")}
      count={get(publisherTheme, ["primary_menu_count"], 6)}
      closeAll={closeAll}
      customCssClasses={`menu-row ${customCssClasses}`}
      type="default"
      isSingleLayer={isSingleLayer}
    />
  );
};

const mapStateToProps = state => {
  const headerTheme = get(
    state.qt,
    ["config", "pagebuilder-config", "header", "headerStyle"],
    get(state.qt, ["config", "theme-attributes", "header_theme"], "header_1")
  );
  const isSingleLayer = headerTheme.includes("single-layer");

  return {
    menu: get(state.qt, ["data", "navigationMenu"], []),
    domainSlug: get(state.qt, ["config", "domainSlug"], ""),
    publisherTheme: get(state.qt, ["config", "theme-attributes"], {}),
    isSingleLayer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeAll: () => dispatch({ type: "CLOSE_ALL" })
  };
};

DefaultMenuBase.propTypes = {
  menu: PropTypes.array,
  domainSlug: PropTypes.string,
  closeAll: PropTypes.func,
  publisherTheme: PropTypes.shape({
    language_direction: PropTypes.string,
    primary_menu_count: PropTypes.string
  }),
  customCssClasses: PropTypes.string,
  isSingleLayer: PropTypes.bool,
  type: PropTypes.string
};

export const DefaultMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultMenuBase);
